export type PopupContentSize =
  | "data" // Info displays - content height
  | "default"; // Default fallback

export const getPopupSizeClasses = (size: PopupContentSize): string => {
  const baseClasses =
    "mx-auto md:rounded-lg bg-white flex flex-col shadow-xl " +
    "min-w-full min-h-full max-h-full max-w-full " +
    "md:min-w-[50%] md:max-w-[75%] md:max-h-[80vh]";

  switch (size) {
    case "data":
      return `${baseClasses} md:min-h-0 overflow-hidden`;
    default:
      return `${baseClasses} md:min-h-[80vh] overflow-clip`;
  }
};
